import { defineStyleConfig, defineStyle } from '@chakra-ui/react'
import { textStyles } from '../foundations/textStyles'

const sizes = {
  xs: defineStyle({
    ...textStyles.xs,
  }),
  sm: defineStyle({
    ...textStyles.sm,
  }),
  md: defineStyle({
    ...textStyles.md,
  }),
  lg: defineStyle({
    ...textStyles.lg,
  }),
  xl: defineStyle({
    ...textStyles.xl,
  }),
}

export const Textarea = defineStyleConfig({
  sizes,
  defaultProps: {
    variant: 'outline',
  },
})
